import React from 'react';
import PropTypes from 'prop-types';

import { PlayerProfilePreview } from '../..';
import './VideoInfoBoxTitle.scss';
// import commentIcon from '../../assets/imgs/comment_indicator.png';

const VideoInfoBoxTitle = ({ sender, title, videoComment }) => {
  const { avatar, lastName, firstName, fullName, avatarBgColor } = sender;

  return (
    <div className="video-info-box-title">
      <PlayerProfilePreview
          avatar={avatar}
          lastName={lastName}
          firstName={firstName}
          fullName={fullName}
          avatarBgColor={avatarBgColor}
      />
      <span className="video-info-box-title__text">{title}</span>
      {!!videoComment && 
        // <img className="video-info-box-title__icon" src={commentIcon} alt='' />
        <span className="video-info-box-title__comment">{videoComment}</span>
      }
    </div>
  );
};

VideoInfoBoxTitle.propTypes = {
  sender: PropTypes.object,
  title: PropTypes.string
};

VideoInfoBoxTitle.defaultProps = {
  sender: {},
  title: ''
};

export default VideoInfoBoxTitle;
